import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

const EventTicketsBasicInfoComponent = ({
    selectedEventTickets,
    events,
    handleInnerFormChange,
    eventsTickets,
    EventType
}: any) => {

    const eventPlan: any = events?.find((et: any) => et.Id === selectedEventTickets?.EventId);
    const listPlan: any = eventPlan?.EventPlans || [];


    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                        <InputContainer
                            label="Event"
                            labelField="Name"
                            list={events}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(event.target.value, 'EventId');

                            }}
                            optionName='Choose Event'
                            type="select"
                            value={selectedEventTickets?.EventId}
                            valueField="Id"
                        />

                        {
                            selectedEventTickets?.EventId && (
                                <InputContainer
                                    label="Event Plans"
                                    labelField="EntityInfo.Title"
                                    list={listPlan}
                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(event.target.value, 'OwnerId');
                                    }}
                                    optionName="Choose Event Plan"
                                    type="select"
                                    value={selectedEventTickets?.OwnerId}
                                    valueField="Id"
                                />
                            )
                        }

                        <InputContainer
                            label="Name"
                            name="Name"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'Name');
                            }}
                            type="text"
                            value={selectedEventTickets?.Name}
                        />

                        <InputContainer
                            label="Price"
                            name="Price"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'Price');
                            }}
                            type="number"
                            value={selectedEventTickets?.Price}
                        />

                        <InputContainer
                            label="Currency"
                            name="Currency"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'Currency');
                            }}
                            type="text"
                            value={selectedEventTickets?.Currency}
                        />

                        <InputContainer

                            label="Is free cost"
                            name="IsFreeOfCost"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'IsFreeOfCost'
                                )
                            }}
                            type="checkbox"
                            value={selectedEventTickets?.IsFreeOfCost}
                        />


                        <InputContainer
                            label="Quantity Available"
                            name="QuantityAvailable"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'QuantityAvailable');
                            }}
                            type="number"
                            value={selectedEventTickets?.QuantityAvailable}
                        />

                        <InputContainer
                            label="Quantity Sold"
                            name="QuantitySold"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'QuantitySold');
                            }}
                            type="number"
                            value={selectedEventTickets?.QuantitySold}
                        />


                        <InputContainer
                            label="Type"
                            labelField="Text"
                            list={EventType}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(event.target.value, 'Type');

                            }}
                            optionName='Choose Type'
                            type="select"
                            value={selectedEventTickets?.Type}
                            valueField="Text"
                        />

                        <InputContainer
                            label="Sale Start Date"
                            name="SaleStartDate"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'SaleStartDate');
                            }}
                            type="date"
                            value={selectedEventTickets?.SaleStartDate}
                        />

                        <InputContainer
                            label="Sale End Date"
                            name="SaleEndDate"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'SaleEndDate');
                            }}
                            type="date"
                            value={selectedEventTickets?.SaleEndDate}
                        />

                        <InputContainer
                            label="Description"
                            name="Description"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'Description');
                            }}
                            type="text"
                            value={selectedEventTickets?.Description}
                        />

                        <div className='col-span-full'>


                            <InputContainer
                                label="Benefits"
                                onValueChange={(newValue: any) => {
                                    const valueData: any = newValue.map((option: any) => option?.id || '')
                                    handleInnerFormChange(
                                        valueData,
                                        'Benefits'

                                    );
                                }}
                                type="multiselectText"
                                value={selectedEventTickets?.Benefits}
                            />

                            <InputContainer
                                label="Terms And Conditions"
                                onValueChange={(newValue: any) => {
                                    const valueData: any = newValue.map((option: any) => option?.id || '')
                                    handleInnerFormChange(
                                        valueData,
                                        'TermsAndConditions'

                                    );
                                }}
                                type="multiselectText"
                                value={selectedEventTickets?.TermsAndConditions}
                            />
                        </div>
                    </div>
                }
                expandedPanel="basicInfo"
                headerTitle="Event Tickets Info"
            />
        </>
    );
};

export default EventTicketsBasicInfoComponent;
